import React from "react";
import { UserPodcastExpirationTemplate } from "themes/administration/user/components";

function UserPodcastExpiration(props) {
    return <UserPodcastExpirationTemplate {...props} />;
}

export default UserPodcastExpiration;
